import classNames from 'classnames';
import { Eye, EyeOff } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { useMutation } from '../../../Shared/api';
import { useNotifier } from '../../../Shared/Notifier/NotificationProvider';
import { Toggle } from '../../../Shared/UI/Toggle';
import { useRouter } from '../../router';
import { DonationForm } from '../../types';

export default function DonationFormToggle({
  donationForm,
}: {
  donationForm: DonationForm;
}) {
  const { t } = useTranslation();
  const { routes } = useRouter();
  const notifier = useNotifier();

  const [toggleDonationForm, { loading }] = useMutation(routes.toggle_donation_form(donationForm.id), {
    preserveScroll: true,
    onSuccess: () => {
      notifier.notify(
        !donationForm.enabled ? t('backend:donation_form_enabled') : t('backend:donation_form_disabled'),
        !donationForm.enabled ? Eye : EyeOff
      );
    },
  });

  return (
    <div className="inline-flex items-center space-x-4">
      <div className={classNames('font-medium', donationForm.enabled ? 'text-emerald-600' : 'text-slate-500')}>
        {donationForm.enabled ? t('backend:live') : t('backend:offline')}
      </div>
      <div className="z-20">
        <Toggle
          checked={donationForm.enabled}
          onChange={() => toggleDonationForm({ enabled: !donationForm.enabled })}
          disabled={donationForm.default || loading}
          aria-label={t(donationForm.enabled ? 'backend:disable_name' : 'backend:enable_name', { name: donationForm.internal_title })}
        />
      </div>
    </div>
  );
}
